import { styled } from "@mui/material";

export const TitleContainer = styled("div")(() => ({
  marginBottom: "0.313rem",
}));
